import set from 'lodash/set';
import { handleOpmlError } from '../../errors/OpmlError';
import { formatEvent } from '../../services/logging/utils';
import transformOpmlResponseHead from '../../transforms/transformOpmlResponseHead';
import tuneInRequest from '../../tuneInRequest';
export function logging(config, apiContext, applyReauth) {
    const infoLogEndpoint = `${config.domains.local}/log/info/`;
    const errorLogEndpoint = `${config.domains.local}/log/error/`;
    const reportEndpoint = `${config.domains.opml}/Report.ashx`;
    function log(endpoint, body) {
        if (apiContext.abTestIds) {
            set(body, 'context.abTestIds', apiContext.abTestIds);
        }
        if (apiContext.partnerId && !body?.context?.partnerId) {
            set(body, 'context.partnerId', apiContext.partnerId);
        }
        if (apiContext.appVersion) {
            set(body, 'context.appVersion', apiContext.appVersion);
        }
        if (apiContext.desktopVersion) {
            set(body, 'context.desktopVersion', apiContext.desktopVersion);
        }
        return tuneInRequest({
            method: 'post',
            url: endpoint,
            data: body,
        }, apiContext);
    }
    function errorLog(body) {
        return log(errorLogEndpoint, body);
    }
    function infoLog(body) {
        return log(infoLogEndpoint, body);
    }
    function report(params, body) {
        return tuneInRequest({
            method: body ? 'post' : 'get',
            url: reportEndpoint,
            params,
            transformResponse: transformOpmlResponseHead,
            disableRetry: true,
            ...(body && { data: body }),
        }, apiContext).then(handleOpmlError);
    }
    function eventLog({ event, params }) {
        return tuneInRequest({
            method: event ? 'post' : 'get',
            url: reportEndpoint,
            params: {
                c: 'eventlist',
                ...params,
            },
            transformResponse: transformOpmlResponseHead,
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded',
            },
            disableRetry: true,
            ...(event && { data: formatEvent(event) }),
        }, apiContext).then(handleOpmlError);
    }
    return {
        eventLog,
        errorLog,
        infoLog,
        report: applyReauth(report),
    };
}
